import { type CookieConsentTranslator } from '#src/assets/lib/i18n.ts'
import { bodyTextStyle } from '#src/assets/ui/shared/styles.ts'

export function SettingsDialogDescription({
  t,
}: {
  t: CookieConsentTranslator
}) {
  return (
    <div className="lcc-settings-dialog__description" style={bodyTextStyle}>
      {t('howWeUseCookiesDescription')}
    </div>
  )
}
